







import Vue from 'vue';
import Component from 'vue-class-component';
import IntersectionDirective from '../../common/vue/intersection-directive';

const ParagraphTextProps = Vue.extend({
  props: {
    textIndent: {
      type: String,
      default: '',
    },
    listStyle: {
      type: String,
      default: 'arrow-right',
    },
    isProminent: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
  },
});

@Component({
  directives: {
    intersect: IntersectionDirective,
  },
})
export default class ParagraphText extends ParagraphTextProps {
  get rootNodeClasses () {
    const classes = ['brandhub-paragraph-indent', 'brandhub-paragraph-text', 'brandhub-list-style'];

    classes.push(`brandhub-list-style-${this.listStyle}`);

    if (this.textIndent !== '') {
      classes.push(this.textIndent);
    }

    if (this.isProminent) {
      classes.push('brandhub-paragraph-text--prominent');
      classes.push(`brandhub-paragraph-text--prominent-${this.listStyle}`);
    }

    return classes.join(' ');
  }
}
